import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import VideoPlayer from 'yoda-site-components/lib/components/VideoPlayer/VideoPlayer';
import * as styles from './InlineVideo.css';
import { videoPlayerAnalytics } from '../../actions/AnalyticsAction';
import VideoContainer from '../VideoContainer/VideoContainer';

const cx = classNames.bind(styles);

/* istanbul ignore next */
export class ProductVideos extends Component {
    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        videos: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        dataAutomationId: PropTypes.string,
        initCallBack: PropTypes.func,
        enableVideoPlacementChange: PropTypes.bool,
    };

    static defaultProps = {
        actions: {},
        videos: [],
        dataAutomationId: null,
        initCallBack: null,
        enableVideoPlacementChange: false,
    };

    constructor() {
        super();
        this.triggerAnalytics = this.triggerAnalytics.bind(this);
    }

    componentDidMount() {
        if (this.props.initCallBack) {
            this.props.initCallBack();
        }
    }

    triggerAnalytics(pageId) {
        const videoPlayerData = window.videojs(pageId);
        this.props.actions.videoPlayerAnalytics(videoPlayerData);
    }

    render() {
        let productVideoID;
        let productVideoType;
        let productVideoUrl;
        const { videos, dataAutomationId, enableVideoPlacementChange } = this.props;
        /* For now, only one video is considered hence video[0] is taken */
        if (Object.keys(videos).length) {
            productVideoID = videos.id;
            productVideoType = videos.type;
            productVideoUrl = videos.url;
        }

        return (
            <div className={cx('productVideos')}>
                {productVideoType === 'Scene7' ? (
                    <div id="productVideos" className={cx('videoParentContainer')}>
                        <div className={cx('videoChildContainer')}>
                            <VideoPlayer
                                url={productVideoUrl}
                                pageId="pdpVideo"
                                playerProps={{ url: productVideoID }}
                                automationId={`${dataAutomationId}-${productVideoID}`}
                                triggerAnalytics={this.triggerAnalytics}
                                disableAutoPlay={!!enableVideoPlacementChange}
                                isPDP
                            />
                        </div>
                    </div>
                ) : (
                    <div className={cx('defaultVideos')}>
                        <VideoContainer url={videos.url} />
                    </div>
                )}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ videoPlayerAnalytics }, dispatch),
});

export default connect(null, mapDispatchToProps)(ProductVideos);
